import React from 'react';
import PropTypes from 'prop-types';
import { Icon, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    color: grey600,
    marginRight: '0.375rem',
  },
});

function SocialShareCopyLink({ handleOpenCopyModal }) {
  return (
    <Icon
      name="share-link"
      onClick={handleOpenCopyModal}
      className={`ppvx_icon--size_lg ${css(styles.iconLink)}`}
      data-testid="social-share-copy-link"
    />
  );
}

SocialShareCopyLink.propTypes = {
  url: PropTypes.string,
  handleOpenCopyModal: PropTypes.func,
};

export default SocialShareCopyLink;
